// extracted by mini-css-extract-plugin
export default {"button":"jgXCfy","wrapper":"xaRdfw","label":"srEdfd","bubble":"tSamLJ"};